import { render, staticRenderFns } from "./BuyComponent.vue?vue&type=template&id=4670d8f1&scoped=true&"
import script from "./BuyComponent.vue?vue&type=script&lang=ts&"
export * from "./BuyComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BuyComponent.vue?vue&type=style&index=0&id=4670d8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670d8f1",
  null
  
)

export default component.exports